import { useEffect, useRef } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Img } from "./Img";

const Modal = ({ isOpen, onClose, title, content }) => {
  const modalRef = useRef(null);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") {
        onClose();
      }
    };

    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener("keydown", handleKeyDown);
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <AnimatePresence>
      <motion.div
        className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-2xl"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
      >
        <motion.div
          ref={modalRef}
          className="bg-[#111115] bg-opacity-80 rounded-[30px] desktop:w-[527px] tablet:w-[427px] mobile:w-[322px] h-auto desktop:h-[527px] p-6 shadow-lg relative"
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          exit={{ scale: 0.8, opacity: 0 }}
        >
          {/* 닫기 버튼 */}
          <button className="absolute top-4 right-4 flex items-center justify-center self-end px-2.5" onClick={onClose}>
          <Img src="images/close.png" />
        </button>

          {/* 모달 내용 */}
          <div className="flex flex-col items-start gap-4 mt-10 pl-[11px] w-[344px] desktop:w-[444px] mobile:w-[247px]">
            <div><h1 className="text-[24px] mobile:text-[21px] font-monasans font-semibold text-white">{title}</h1></div>
            <p className="text-[24px] mobile:text-[16px] font-monasans font-light text-white opacity-70 w-[344px] desktop:w-[444px] mobile:w-[274px]">
              {content}
            </p>
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
};

export default Modal;
